import { render, staticRenderFns } from "./saasFormItem.vue?vue&type=template&id=5a6b3740&scoped=true&"
import script from "./saasFormItem.vue?vue&type=script&lang=js&"
export * from "./saasFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6b3740",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/nisems/front/nisbos-front-admin/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a6b3740')) {
      api.createRecord('5a6b3740', component.options)
    } else {
      api.reload('5a6b3740', component.options)
    }
    module.hot.accept("./saasFormItem.vue?vue&type=template&id=5a6b3740&scoped=true&", function () {
      api.rerender('5a6b3740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ls-form/components/saas/saasFormItem.vue"
export default component.exports